import { render, staticRenderFns } from "./bookDetail.vue?vue&type=template&id=b173b2ec&scoped=true&"
import script from "./bookDetail.vue?vue&type=script&lang=js&"
export * from "./bookDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookDetail.vue?vue&type=style&index=0&id=b173b2ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b173b2ec",
  null
  
)

export default component.exports